<results-filters-box
  [filters]="filters"
  [enableClearAll]="true"
  [showClearIcon]="false"
  (filterChange)="onFilterChange($event)"
  (clearAll)="clearAllFilters()"
  [ngClass]="{ 'results-filters-box-extension': !isExtension }"
></results-filters-box>
